import type { MantineThemeOverride } from '@mantine/core'

export const theme: MantineThemeOverride = {
  primaryColor: 'brand-highlight',
  // Colors are set in the core package in the component library, then we can override them here if needed
  // colors: {
  // },

  //
  //  Font Sizes px to rem conversion
  //
  // 8px = 0.5rem
  // 10px = 0.625rem
  // 12px = 0.75rem
  // 14px = 0.875rem
  // 16px = 1rem (default value)
  // 18px = 1.125rem
  // 20px = 1.25rem
  // 22px = 1.375rem
  // 24px = 1.5rem
  // 26px = 1.625rem
  // 28px = 1.75rem
  // 32px = 2rem
  // 36px = 2.25rem
  // 40px = 2.5rem
  // 44px = 2.75rem
  // 48px = 3rem
  fontSizes: {
    xxs: '0.875rem', // 14px
    xs: '1rem', // 16px
    sm: '1.125rem', // 18px
    md: '1.25rem', // 20px
    lg: '1.375rem', // 22px
    xl: '1.625rem', // 26px
  },

  headings: {
    fontWeight: '600',
    sizes: {
      h1: {
        fontSize: 'clamp(36px, 6vw, 72px)',
        lineHeight: '1.1',
      },
      h2: {
        fontSize: 'clamp(22px, 4vw, 48px)',
        lineHeight: '1',
        fontWeight: '600',
      },
      h3: {
        fontSize: 'clamp(26px, 3.5vw, 36px)',
        lineHeight: '1',
      },
      h4: {
        fontSize: 'clamp(18px, 2.2vw, 22px)',
        lineHeight: '1',
      },
      h5: {
        fontSize: 'clamp(16px, 2vw, 20px)',
        lineHeight: '1',
      },
      h6: {
        fontSize: 'clamp(14px, 1.8vw, 18px)',
        lineHeight: '1',
      },
    },
  },
  // components: {
  //   Text: {
  //     defaultProps: {
  //       fontSize: 'clamp(18px, 1.6vw, 22px)',
  //     },
  //   },
  // },
}
